/**
 * CDB-2017 — the "Simplified Sidebar" layout (Configure Role → Sidebar Settings → Simplified
 * Sidebar). Takes the menu already filtered to the role's top-level entries and:
 * - shows a group with a single visible item as that item, keeping the group's icon;
 * - for a group flagged `promoteChildrenInSimplifiedSidebar` (Monitoring And Control), shows its
 *   visible items directly in the menu, without the heading (e.g. Charger Status);
 * - for a group flagged `flattenInSimplifiedSidebar` (Reports), lists the visible items of its
 *   sub-groups directly under it (no Basic / Advance / Custom Reports headings);
 * - drops groups left with nothing visible.
 * Which items are visible is still decided by the role's modules (`visibleItems`).
 */
export const simplifySidebarMenu = (menu, visibleItems) =>
  menu
    .flatMap((item) => {
      if (!item.children) {
        return item;
      }
      const children = visibleItems(item.children)
        .map((child) => (child.children ? { ...child, children: visibleItems(child.children) } : child))
        .filter((child) => !child.children || child.children.length > 0);

      if (item.promoteChildrenInSimplifiedSidebar) {
        return children.flatMap((child) => child.children || [child]).map((child) => ({ ...child, icon: child.icon || item.icon }));
      }
      if (item.flattenInSimplifiedSidebar) {
        const flat = children.flatMap((child) => child.children || [child]);
        return flat.length > 0 ? { ...item, children: flat } : null;
      }
      if (children.length === 1 && !children[0].children) {
        return { ...children[0], icon: children[0].icon || item.icon };
      }
      return children.length > 0 ? { ...item, children } : null;
    })
    .filter(Boolean);
